<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="user-tab" data-bs-toggle="tab" data-bs-target="#user-tab-pane" type="button" role="tab" aria-controls="user-tab-pane" aria-selected="true">بيانات العميل</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="nafath-tab" data-bs-toggle="tab" data-bs-target="#nafath-tab-pane" type="button" role="tab" aria-controls="nafath-tab-pane" aria-selected="false">بيانات نفاذ</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="banks-tab" data-bs-toggle="tab" data-bs-target="#banks-tab-pane" type="button" role="tab" aria-controls="banks-tab-pane" aria-selected="false">الحسابات البنكية</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade p-3 show active" id="user-tab-pane" role="tabpanel" aria-labelledby="user-tab" tabindex="0">

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الصورة الشخصية:</label>
                  <div>
                    <img v-if="dataRow.avatar" :src="MEDIA_URL+dataRow.avatar" class="img-thumbnail" style="max-width: 200px;" alt="">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الاسم:</label>
                  <div>{{ name }}</div>
                </div>
          
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">رقم الهوية:</label>
                  <div>{{ dataRow.identity }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الجوال:</label>
                  <div>{{ dataRow.mobile }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">تفعيل رقم الجوال:</label>
                  <div>{{ (dataRow.mobileVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">البريد الإلكتروني:</label>
                  <div>{{ dataRow.email }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">تفعيل البريد الإلكتروني:</label>
                  <div>{{ (dataRow.emailVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">التخصص:</label>
                  <div v-for="i in dataRow.MaintenanceIssues" :key="i.id">{{ i.name }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">حالة نفاذ:</label>
                  <div>{{ dataRow.nafathStatus }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">آخر تسجيل دخول:</label>
                  <div class="date-format">{{ (dataRow.lastLogin)? formatDate(dataRow.lastLogin) : '' }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">حالة الحظر:</label>
                  <div>{{ (isBlocked)? 'محظور' : 'غير محظور' }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">حالة الحساب:</label>
                  <div>{{ statusObject[status] }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label class="form-label">عمولة مخصصة:</label>
                  <div>
                    <span v-if="dataRow.hasCustomCommission" class="badge bg-warning text-dark">
                      <i class="fas fa-percent me-1"></i> مفعلة
                    </span>
                    <span v-else class="badge bg-secondary">غير مفعلة — يطبق الإعداد الافتراضي</span>
                  </div>
                </div>
                <div v-if="dataRow.hasCustomCommission" class="col-12 col-sm-6 mb-3">
                  <label class="form-label">تفاصيل العمولة:</label>
                  <div v-if="dataRow.customCommissionPercentage">
                    نسبة: <strong>{{ dataRow.customCommissionPercentage }}%</strong>
                  </div>
                  <div v-else class="text-muted">لم تحدد قيمة</div>
                </div>
              </div>
            </div>
            <!-- Nafath -->
            <div class="tab-pane fade p-3" id="nafath-tab-pane" role="tabpanel" aria-labelledby="nafath-tab" tabindex="0">
              <div v-if="!dataRow.NafathProvider" class="row">
                <div class="col">
                  <div class="alert alert-info">لم يتم الحصول على بيانات من قبل نفاذ</div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">معرف المستخدم:</label>
                      <div>{{ dataRow.NafathProvider.nin }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">كود الجنسية:</label>
                      <div>{{ dataRow.NafathProvider.nationality }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رقم إصدار الهوية:</label>
                      <div>{{ dataRow.NafathProvider.idVersionNumber }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">مكان إصدار الهوية:</label>
                      <div>{{ dataRow.NafathProvider.idIssuePlace }}</div>
                      <div>{{ dataRow.NafathProvider.iqamaIssuePlaceDesc }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إصدار الهوية - ميلادي:</label>
                      <div>{{ dataRow.NafathProvider.idIssueDateG }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إصدار الهوية - هجري:</label>
                      <div>{{ dataRow.NafathProvider.idIssueDate }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إنتهاء الهوية - ميلادي:</label>
                      <div>{{ dataRow.NafathProvider.idExpiryDateG }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إنتهاء الهوية - هجري:</label>
                      <div>{{ dataRow.NafathProvider.idExpiryDate }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الجنس:</label>
                      <div>{{ dataRow.NafathProvider.gender }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الاسم الاول:</label>
                      <div>{{ dataRow.NafathProvider.firstName }}</div>
                      <div>{{ dataRow.NafathProvider.englishFirstName }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم العائلة:</label>
                      <div>{{ dataRow.NafathProvider.familyName }}</div>
                      <div>{{ dataRow.NafathProvider.englishLastName }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم الاب:</label>
                      <div>{{ dataRow.NafathProvider.fatherName }}</div>
                      <div>{{ dataRow.NafathProvider.englishSecondName }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم الجد:</label>
                      <div>{{ dataRow.NafathProvider.grandFatherName }}</div>
                      <div>{{ dataRow.NafathProvider.englishThirdName }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ الميلاد:</label>
                      <div>{{ dataRow.NafathProvider.dateOfBirthG }}</div>
                      <div>{{ dataRow.NafathProvider.dateOfBirthH }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الحالة الاجتماعية:</label>
                      <div>{{ (socialStatusCodeObj[dataRow.NafathProvider.socialStatusCode] && socialStatusCodeObj[dataRow.NafathProvider.socialStatusCode][dataRow.NafathProvider.gender])? socialStatusCodeObj[dataRow.NafathProvider.socialStatusCode][dataRow.NafathProvider.gender] : 'غير معروف' }}</div>
                      <div>{{ dataRow.NafathProvider.socialStatusDesc }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ آخر سفر - خروج:</label>
                      <div>{{ dataRow.NafathProvider.lastTravelExitDateG }}</div>
                      <div>{{ dataRow.NafathProvider.lastTravelExitDate }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ آخر سفر - دخول:</label>
                      <div>{{ dataRow.NafathProvider.lastTravelEntryDateG }}</div>
                      <div>{{ dataRow.NafathProvider.lastTravelEntryDate }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">محل الميلاد:</label>
                      <div>{{ dataRow.NafathProvider.placeOfBirth }}</div>
                      <div>{{ dataRow.NafathProvider.placeOfBirthDesc }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رقم جواز السفر:</label>
                      <div>{{ dataRow.NafathProvider.passportNumber }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رمز المهنة:</label>
                      <div>{{ dataRow.NafathProvider.occupationCode }}</div>
                      <div>{{ dataRow.NafathProvider.occupationDesc }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">عدد المعالين:</label>
                      <div>{{ dataRow.NafathProvider.totalNumberOfCurrentDependents }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">كود الجنسية:</label>
                      <div>{{ dataRow.NafathProvider.nationalityCode }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الجنسية:</label>
                      <div>{{ dataRow.NafathProvider.nationalityDesc }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">العنوان الوطني:</label>
                      <div>{{ dataRow.NafathProvider.nationalAddress }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">قاصر:</label>
                      <div>{{ dataRow.NafathProvider.isMinor }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رب الاسرة:</label>
                      <div>{{ dataRow.NafathProvider.hohInfo }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">قاصر:</label>
                      <div>{{ dataRow.NafathProvider.isMinor }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم الكفيل:</label>
                      <div>{{ dataRow.NafathProvider.sponsorName }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الوضع القانوني:</label>
                      <div>{{ dataRow.NafathProvider.legalStatus }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الحالة الاجتماعية:</label>
                      <div>{{ dataRow.NafathProvider.socialStatus }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الوضع القانوني:</label>
                      <div>{{ dataRow.NafathProvider.legalStatus }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">مؤشر الدخول والخروج:</label>
                      <div>{{ dataRow.NafathProvider.inOutIndecator }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">كود محل الميلاد:</label>
                      <div>{{ dataRow.NafathProvider.placeOfBirthCode }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Bank Accounts -->
            <div class="tab-pane fade p-3" id="banks-tab-pane" role="tabpanel" aria-labelledby="banks-tab" tabindex="0">
              <ProviderBanks :banks="dataRow.ProvidersBanks" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';
import ProviderBanks from '@/components/ProviderBanks.vue';

export default {
  name: 'ProvidersView',
  components: { ProviderBanks },
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: {},
    },
    specializationList: {
      type: Array,
      default: [],
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      restoreLoader: false,
      socialStatusCodeObj: {
        '0': {M: 'اعزب', F: 'غير معروف'},
        '1': {M: 'زوجة واحدة', F: 'غير متزوجة'},
        '2': {M: 'زوجتين', F: 'متزوجه'},
        '3': {M: 'ثلاث زوجات', F: 'مطلقه'},
        '4': {M: 'أربع زوجات', F: 'أرمله'},
        '5': {M: 'غير معروف', F: 'مطلقة معلقة'},
      },
      name: '',
      isBlocked: false,
      status: null,
      specialization: null,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL']),
  },
  methods: {
    formatDate,
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.isBlocked = this.dataRow.isBlocked;
      this.status = this.dataRow.status;
      if(this.dataRow.MaintenanceIssues.length){
        this.specialization = this.dataRow.MaintenanceIssues[0].id;
      }
    }
  }
}
</script>